import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    VerificationService,
    SuccessResponse,
    getLogoUrl,
    LogoComponent,
    CopyToClipboard,
    FormFooterComponent as FormFooter,
} from '@sheerid/jslib';
import { redirect } from '../lib/utils/browser';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const hasLogo = getLogoUrl(verificationService.programTheme);
    const redirectDestination = (verificationService.verificationResponse as SuccessResponse).redirectUrl;
    const showRedirect = Boolean(redirectDestination);
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}'; // eslint-disable-line no-template-curly-in-string

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo
                        ? <LogoComponent verificationService={verificationService} />
                        : (
                            <img
                                className="sid-l-lead-image"
                                alt="design element"
                                src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                            />
                        )}
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage="Here is your personal coupon code. It is unique to you and can only be used once." />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>
            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <div className="sid-footer__return-to-levis">
                    <FormattedHTMLMessage id="step.success.returnToLevis" defaultMessage="Please return to <a href='https://www.levi.com/US/en_US/' class='sid-link' target='_blank'>www.levis.com</a> to continue shopping." />
                </div>
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage="To make sure you have every opportunity to use your discount, we're also emailing you a copy of your code and a link to the Levi's website so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all of the details." />
            </div>

            {
                (showRedirect)
                    ? (
                        <div className="sid-submit sid-l-space-top-md">
                            <button
                                onClick={() => redirect(redirectDestination as string)}
                                className="sid-btn sid-btn--dark"
                                type="button"
                            >
                                <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                            </button>
                        </div>
                    ) : ''
            }

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormFooter verificationService={verificationService} />
            </div>
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;
